<div class="title-bar-container font-bold">
    <div class="panel-heading d-print-none" [ngClass]="{'hasBackBtn':backNavigation, 'isFlat': flat}">
        <div *ngIf="backNavigation" (click)="goBack()" class="action mr-3"><i class="fa fa-chevron-left"></i></div>
        <span>
            {{title | uppercase}}
        </span>
    </div>
    <div *ngIf="primarySubtitle" class="subtitle-bar">
        <div class="row flat">
            <div class="col flat">
                <div class="subtitle primary" [ngClass]="{'border-radius':!secondarySubtitle}">{{primarySubtitle}}</div>
            </div>
            <div *ngIf="secondarySubtitle" style="white-space: nowrap;" class="col flat">
                <div class="subtitle secondary">{{secondarySubtitle || 'N/A'}}</div>
            </div>
            <!-- <div *ngIf="isFromMilStd">
                <div class="subtitle secondary btn-action bg-orange">
                    <span *ngIf="!selectedProject">Add cutsheet to project</span>
                    <select class="shrink" [(ngModel)]="selectedProject" style="background: none; border: none" #project (change)="assignProject(project.value)">
                        <option value="Add cutsheet to project"></option>
                        <option *ngFor="let proj of projects" [value]="proj.id">{{proj.projectname}}</option>
                    </select>
                    <span class="chevron"></span>
                </div>
            </div> -->
        </div>
    </div>
</div>